<template>
  <div>
    <div v-if="isResendSuccessful" class="mb-3">
      <span>
        {{ this.$t('login.message.request_resend_active') }}
      </span>
    </div>
    <div v-else>
      <div>
      <span>
       {{ this.$t('login.message.account_notactivated') }}
      </span>
      </div>
      <div class="mt-3">
        <strong>{{ this.$t('login.label.your_email') }}:</strong>
        <br/>
        <span class="text-success">
        {{ email }}
      </span>
      </div>

      <button
          type="button"
          class="btn bg-gradient-primary w-100 mt-4 mb-2"
          @click="resendEmail"
      >
        {{ this.$t('login.button.resend_activation') }} <span class="fa fa-envelope" />
      </button>
    </div>

    <button
        type="button"
        class="btn bg-gradient-success w-100 mb-2"
        @click="backToLogin"
    >
      {{ this.$t('login.button.back_to_login') }} <span class="fa fa-arrow-left" />
    </button>
  </div>
</template>

<script>

import DataRequester from "../../../mixins/utilities/DataRequester";

export default {
  name: 'ResendActivationEmail',
  mixins: [DataRequester],
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isResendSuccessful: false
    }
  },
  methods: {
    resendEmail() {
      const self = this
      this.getDataFromAPI(this.$config.apiPath.resendActivationEmail, function () {
        self.$toasted.success(self.$t('login.message.request_activation_success'))
        self.isResendSuccessful = true
      })
    },
    backToLogin() {
      this.$emit('login-click');
    }
  }
}
</script>